module.exports = __webpack_public_path__ + "assets/img/danceBg.b158060b.png";